import { render, staticRenderFns } from "./SharerRateVersion.vue?vue&type=template&id=5513c5da&scoped=true"
import script from "./SharerRateVersion.vue?vue&type=script&lang=js"
export * from "./SharerRateVersion.vue?vue&type=script&lang=js"
import style0 from "./SharerRateVersion.vue?vue&type=style&index=0&id=5513c5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513c5da",
  null
  
)

export default component.exports